import { useCallback, useState } from 'react';
import { LanguagePairLink } from 'src/types/link';
import { LinkImage } from '../LinkImage';
import { SidebarButtonWithArrow } from '../SidebarButtonWithArrow';
import * as S from './styles';

type SidebarSublistProps = {
  buttonText: string;
  links: LanguagePairLink[];
};

export const SidebarSublist = ({ buttonText, links }: SidebarSublistProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleBtnClick = useCallback(() => {
    setIsOpen(currentState => !currentState);
  }, [setIsOpen]);

  return (
    <>
      <SidebarButtonWithArrow onClick={handleBtnClick}>{buttonText}</SidebarButtonWithArrow>

      {isOpen && (
        <S.Sublist>
          {links.map(link => (
            <S.SublistItem key={link.text}>
              <S.SublistItemContent>
                <S.SublistItemFlag>
                  <LinkImage {...link.image} />
                </S.SublistItemFlag>
                <S.SublistLink href={link.href}>{link.text}</S.SublistLink>
              </S.SublistItemContent>
            </S.SublistItem>
          ))}
        </S.Sublist>
      )}
    </>
  );
};
